const gridBase = 4;
const space = [];

for (let counter = 0; counter < 60; counter += 1) {
  space.push(counter * gridBase);
}

export default space;
